<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" :inline="true" class="demo-form-inline"
          style="padding-top:0;margin-top:0">
          <el-form-item label="分拣组名称：">
            <el-input size="medium" v-model="searchForm.GROUP_NAME" clearable @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item label="项目名称：">
            <el-input size="medium" v-model="searchForm.PROJECT_NAME" clearable @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-button size="medium" @click="creatNewVisible = true">新增分拣组</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="分拣组名称" prop="GROUP_NAME"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="matchedProject(scope.row)" type="text">匹配项目</el-button>
              <el-button @click="edit(scope.row)" type="text">修改</el-button>
              <el-button @click="deleteSortingGroup(scope.row)" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <!-- 新增分拣组 -->
    <el-dialog title="新增分拣组" center :visible.sync="creatNewVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" :model="creatNewForm" ref="creatNewForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="分拣组名称：" label-width="120px" prop="GROUP_NAME">
          <el-input v-model="creatNewForm.GROUP_NAME" clearable @keyup.enter.native="submitCreat('creatNewForm')">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('creatNew')">取 消</el-button>
        <el-button size="small" @click="submitCreat('creatNewForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改分拣组名称 -->
    <el-dialog title="修改分拣组名称" center :visible.sync="editVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" :model="editForm" ref="editForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="分拣组名称：" label-width="120px" prop="GROUP_NAME">
          <el-input v-model="editForm.GROUP_NAME" clearable @keyup.enter.native="submitEdit('editForm')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('edit')">取 消</el-button>
        <el-button size="small" @click="submitEdit('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      creatNewVisible: false,
      creatNewForm: {},
      editVisible: false,
      editForm: {},
      rules: { GROUP_NAME: [{ required: true, message: '请输入分拣组名称', trigger: 'change' }] },
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SORTING_GROUP_MANAGEMENT_CONDITION.CONDITION) {
      this.searchForm = this.SORTING_GROUP_MANAGEMENT_CONDITION.CONDITION;
      this.currentPage = this.SORTING_GROUP_MANAGEMENT_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
  computed: {
    SORTING_GROUP_MANAGEMENT_CONDITION() {
      return this.$store.state.SORTING_GROUP_MANAGEMENT_CONDITION;
    },
  },
  methods: {
    // 筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 18,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.GROUP_NAME) {
        params.GROUP_NAME = this.searchForm.GROUP_NAME;
      }
      if (this.searchForm.PROJECT_NAME) {
        params.PROJECT_NAME = this.searchForm.PROJECT_NAME;
      }
      http.post(params).then((result) => {
        this.tableData = result.LIST;
        this.totalCount = result.TOTAL_COUNT;
        if (!this.totalCount) this.$message.show({ text: '暂无数据', type: 'warning' });
        this.$store.dispatch('SET_SORTING_GROUP_MANAGEMENT_CONDITION', { CONDITION: this.searchForm, CURRENT_PAGE: this.currentPage });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    submitCreat(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const params = {
            SERVICE_ID: '10049',
            OTYPE: 15,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            GROUP_NAME: this.creatNewForm.GROUP_NAME,
          };
          http.post(params).then((res) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.close('creatNew');
            this.handleSearch();
          }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
        } else {
          return false;
        }
      });
    },
    edit(row) {
      this.editForm = { ...row };
      this.editVisible = true;
    },
    submitEdit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const params = {
            SERVICE_ID: '10049',
            OTYPE: 17,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            ID: this.editForm.ID,
            GROUP_NAME: this.editForm.GROUP_NAME,
          };
          http.post(params).then((res) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.close('edit');
            this.handleSearch();
          }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
        } else {
          return false;
        }
      });
    },
    deleteSortingGroup(row) {
      this.$confirm('删除分拣组将解除匹配该组内所有项目点，您确定删除该分拣组吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          const params = {
            SERVICE_ID: '10049',
            OTYPE: 16,
            ID: row.ID,
          };
          http.post(params)
            .then((result) => {
              this.$message.show({ text: '删除成功', type: 'success' });
              this.queryTable();
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
        }).catch(() => {
          this.$message.show({ type: 'info', text: '取消操作' });
        });
    },
    close(form) {
      this[`${form}Visible`] = false;
      this[`${form}Form`] = {};
    },
    matchedProject(row) {
      this.$router.push({ path: `/sortingGroupMatchedProjrct/${row.ID}`, params: { id: row.ID } });
    },
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/sortingGroupManagement.vue